import { useEffect, useState } from "react";

export const useServiceFormLogic = ({ values, form, initialValues }) => {
  const leaderUuid = values?.technicianOrTeamLeader?.uuid;

  const isGroupEnabledInit =
    (initialValues?.techniciansInTheGroup?.length ?? 0) > 0;

  const [isGroupEnabled, setIsGroupEnabled] = useState(isGroupEnabledInit);

  // reset pól gdy brak klienta
  useEffect(() => {
    if (!values?.device?.client) {
      form.change("requester", null);
      form.change("preferredTechnician", null);
      form.change("technicianOrTeamLeader", null);
    }
  }, [values?.device?.client, form]);

  // usunięcie lidera z grupy
  useEffect(() => {
    if (!leaderUuid) return;

    const current = values?.techniciansInTheGroup ?? [];
    const filtered = current.filter((tech) => tech.uuid !== leaderUuid);

    if (current.length === filtered.length) return;

    form.change("techniciansInTheGroup", filtered);
  }, [leaderUuid, values?.techniciansInTheGroup, form]);

  // wyłączenie grupy
  useEffect(() => {
    if (!isGroupEnabled) {
      const current = values?.techniciansInTheGroup ?? [];

      if (current.length === 0) return;

      form.change("techniciansInTheGroup", []);
    }
  }, [isGroupEnabled, values?.techniciansInTheGroup, form]);

  return {
    leaderUuid,
    leaderSelected: !!leaderUuid,
    isGroupEnabled,
    setIsGroupEnabled,
  };
};
